import api from "../../services/api";

export const makeApiGroup = (groupName) => ({
  get: (url, config = {}) =>
    api.get(url, {
      ...config,
      params: { ...(config.params || {}), groupName },
    }),
  post: (url, data, config = {}) =>
    api.post(url, data, {
      ...config,
      params: { ...(config.params || {}), groupName },
    }),
});
